/*
 * @Description:  模版文件url
 */
// *导入模板-小班
const smallClassGroup =
  "https://wlxyoss4t.oss-cn-hangzhou-zwynet-d01-a.internet.cloud.zj.gov.cn/class/%E5%88%86%E7%BB%84%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF-%E5%B0%8F%E7%8F%AD.xlsx";

//* 分组导入模板
const classGroup =
  "https://wlxyoss4t.oss-cn-hangzhou-zwynet-d01-a.internet.cloud.zj.gov.cn/class/%E5%88%86%E7%BB%84%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx";

//* 图书导入模板
const bookTemplate =
  "https://wlxyoss4t.oss-cn-hangzhou-zwynet-d01-a.internet.cloud.zj.gov.cn/book/%E5%9B%BE%E4%B9%A6%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx";

// * 班级学员导入模板
const classStudentTemplate =
  "https://wlxyoss4t.oss-cn-hangzhou-zwynet-d01-a.internet.cloud.zj.gov.cn/class/%E7%8F%AD%E7%BA%A7%E5%AD%A6%E5%91%98%E5%AF%BC%E5%85%A5%E6%A8%A1%E7%89%88.xlsx";

// * 培训班级导入模板
const trainClassTemplate =
  "https://wlxyoss4t.oss-cn-hangzhou-zwynet-d01-a.internet.cloud.zj.gov.cn/class/%E5%9F%B9%E8%AE%AD%E7%8F%AD%E7%BA%A7%E5%AF%BC%E5%85%A5%E6%A8%A1%E7%89%88.xlsx";

//*学员导入模板
const studentsTemplate =
  "https://wlxyoss4t.oss-cn-hangzhou-zwynet-d01-a.internet.cloud.zj.gov.cn/class/%E5%AD%A6%E5%91%98%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx";

// *考试学员导入模板
const examCollageTemplate =
  "https://wlxyoss4t.oss-cn-hangzhou-zwynet-d01-a.internet.cloud.zj.gov.cn/exam/%E8%80%83%E8%AF%95%E5%AD%A6%E5%91%98%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx";

// *试题导入模板
const questionsTemplate =
  "https://wlxyoss4t.oss-cn-hangzhou-zwynet-d01-a.internet.cloud.zj.gov.cn/exam/%E8%AF%95%E9%A2%98%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx";

// *调查人员导入模板
const surveyMemberTemplate =
  "https://wlxyoss4t.oss-cn-hangzhou-zwynet-d01-a.internet.cloud.zj.gov.cn/exam/%E8%B0%83%E6%9F%A5%E4%BA%BA%E5%91%98%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx";

// *非系统用户导入模板
const notSystemUserTemplate =
  "https://wlxyoss4t.oss-cn-hangzhou-zwynet-d01-a.internet.cloud.zj.gov.cn/user/%E9%9D%9E%E7%B3%BB%E7%BB%9F%E7%94%A8%E6%88%B7%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx";

// *用户批量导入模板
const userPatchTemplate =
  "https://wlxyoss4t.oss-cn-hangzhou-zwynet-d01-a.internet.cloud.zj.gov.cn/user/%E7%94%A8%E6%88%B7%E6%89%B9%E9%87%8F%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx";

// *导入联络员和自习室模板
const liaisonRoomTemplate =
  "https://wlxyoss4t.oss-cn-hangzhou-zwynet-d01-a.internet.cloud.zj.gov.cn/class/%E5%AF%BC%E5%85%A5%E8%81%94%E7%BB%9C%E5%91%98%E6%A8%A1%E6%9D%BF.xlsx";

  // 联络员管理-导入联络员模板
const liaisonTemplate =
  "https://wlxyoss4t.oss-cn-hangzhou-zwynet-d01-a.internet.cloud.zj.gov.cn/class/%E5%88%86%E7%BB%84%E8%81%94%E7%BB%9C%E5%91%98%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx";

// *导入教学管理日程安排
const dailyScheduleTemplate =
  "https://wlxyoss4t.oss-cn-hangzhou-zwynet-d01-a.internet.cloud.zj.gov.cn/class/%E6%97%A5%E7%A8%8B%E5%AE%89%E6%8E%92%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx";

// *导入专题讲座模板
const topicLectureTemplate =
  "https://wlxyoss4t.oss-cn-hangzhou-zwynet-d01-a.internet.cloud.zj.gov.cn/class/%E4%B8%93%E9%A2%98%E8%AE%B2%E5%BA%A7%E5%AF%BC%E5%85%A5%E6%A8%A1%E7%89%88.xlsx";

// *退休用户导入模板（手机号码匹配）模板
const retireImportByMobileTemplate =
  "https://wlxyoss4t.oss-cn-hangzhou-zwynet-d01-a.internet.cloud.zj.gov.cn/user/%E9%80%80%E4%BC%91%E7%94%A8%E6%88%B7%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF%EF%BC%88%E6%89%8B%E6%9C%BA%E5%8F%B7%E7%A0%81%E5%8C%B9%E9%85%8D%EF%BC%89%20%20.xlsx";

// *退休用户导入模板（姓名+出生年月匹配） 模板
const retireImportByBirthdayTemplate =
  "https://wlxyoss4t.oss-cn-hangzhou-zwynet-d01-a.internet.cloud.zj.gov.cn/user/%E9%80%80%E4%BC%91%E7%94%A8%E6%88%B7%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF%EF%BC%88%E5%A7%93%E5%90%8D%2B%E5%87%BA%E7%94%9F%E5%B9%B4%E6%9C%88%E5%8C%B9%E9%85%8D%EF%BC%89%20.xlsx";

const retireImportTemplate =
  "https://wlxyoss4t.oss-cn-hangzhou-zwynet-d01-a.internet.cloud.zj.gov.cn/user/%E7%94%A8%E6%88%B7%E6%89%B9%E9%87%8F%E6%9B%B4%E6%96%B0%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx";



// *导入教学管理日程安排
const seatImportTemplate =
  "https://wlxyoss4t.oss-cn-hangzhou-zwynet-d01-a.internet.cloud.zj.gov.cn/class/%E5%BA%A7%E4%BD%8D%E5%8F%B7%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx";

// *导入审核信息表
const videoIncludeInfoTemplate =
  "https://wlxyoss4t.oss-cn-hangzhou-zwynet-d01-a.internet.cloud.zj.gov.cn/video/%E5%AE%A1%E6%9F%A5%E4%BF%A1%E6%81%AF%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx";

// 培训班级导入模版(中组部选调班).xlsx
const centerSelectClassTemplate =
  "https://wlxyoss4t.oss-cn-hangzhou-zwynet-d01-a.internet.cloud.zj.gov.cn/class/%E5%9F%B9%E8%AE%AD%E7%8F%AD%E7%BA%A7%E5%AF%BC%E5%85%A5%E6%A8%A1%E7%89%88(%E4%B8%AD%E7%BB%84%E9%83%A8%E9%80%89%E8%B0%83%E7%8F%AD).xlsx";

// 自习室管理导入模板
const roomManageTemplate =
  "https://wlxyoss4t.oss-cn-hangzhou-zwynet-d01-a.internet.cloud.zj.gov.cn/class/%E8%87%AA%E4%B9%A0%E5%AE%A4%E7%BB%84%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF%20%20.xlsx"

// 权限转让模板
const permissionTransferTemplate =
  "https://wlxyoss4t.oss-cn-hangzhou-zwynet-d01-a.internet.cloud.zj.gov.cn/user/%E6%9D%83%E9%99%90%E8%BD%AC%E8%AE%A9%E7%94%B3%E8%AF%B7%E6%A8%A1%E7%89%88.docx"

// 直播管理-用户导入模版
const liveExportUserTemplate =
  "https://wlxyoss4t.oss-cn-hangzhou-zwynet-d01-a.internet.cloud.zj.gov.cn/user/%E7%9B%B4%E6%92%AD%E7%94%A8%E6%88%B7%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF%20.xlsx"

const questionnaireTemplate = "https://wlxyoss4t.oss-cn-hangzhou-zwynet-d01-a.internet.cloud.zj.gov.cn/questionnaire/%E9%97%AE%E5%8D%B7%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx"

const topicLectureLearnTemplate = "https://wlxyoss4t.oss-cn-hangzhou-zwynet-d01-a.internet.cloud.zj.gov.cn/class/%E7%90%86%E8%AE%BA%E4%B8%AD%E5%BF%83%E7%BB%84%E5%AD%A6%E4%B9%A0%E5%AF%BC%E5%85%A5%E6%A8%A1%E7%89%88.xlsx"


const tempModifyMobileTemplate = "https://wlxyoss4t.oss-cn-hangzhou-zwynet-d01-a.internet.cloud.zj.gov.cn/user/%E6%B5%99%E9%87%8C%E5%AD%A6%E4%B9%A0%E5%B9%B3%E5%8F%B0%E4%BF%AE%E6%94%B9%E6%89%8B%E6%9C%BA%E5%8F%B7%E7%94%B3%E8%AF%B7%E8%A1%A8.docx"
// CDN加速-导入
const cdnRecordTemplate =
  "https://wlxyoss4t.oss-cn-hangzhou-zwynet-d01-a.internet.cloud.zj.gov.cn/video/CDN%E5%8A%A0%E9%80%9F%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF%20.xlsx"

const admissionNoticeTemplate = "https://wlxyoss4t.oss-cn-hangzhou-zwynet-d01-a.internet.cloud.zj.gov.cn/class/%E5%85%A5%E5%AD%A6%E9%80%9A%E7%9F%A5%E4%B9%A6%E6%A8%A1%E7%89%88.docx"
// 导入其他集中培训记录
const otherTrainRecordTemplate =
  "https://wlxyoss4t.oss-cn-hangzhou-zwynet-d01-a.internet.cloud.zj.gov.cn/class/%E5%85%B6%E4%BB%96%E9%9B%86%E4%B8%AD%E5%9F%B9%E8%AE%AD%E5%AF%BC%E5%85%A5%E6%A8%A1%E7%89%88.xlsx"


  const offlineVideoTemplate =
  "https://wlxyoss4t.oss-cn-hangzhou-zwynet-d01-a.internet.cloud.zj.gov.cn/class/%E5%AF%BC%E5%85%A5%E4%B8%8B%E7%BA%BF%E8%A7%86%E9%A2%91%E6%A8%A1%E6%9D%BF.xlsx"

  const offlineVideoSetTemplate =
  "https://wlxyoss4t.oss-cn-hangzhou-zwynet-d01-a.internet.cloud.zj.gov.cn/class/%E5%AF%BC%E5%85%A5%E4%B8%8B%E7%BA%BF%E8%A7%86%E9%A2%91%E9%9B%86%E6%A8%A1%E6%9D%BF.xlsx"

   const classWorkerTemplate =
  "https://wlxyoss4t.oss-cn-hangzhou-zwynet-d01-a.internet.cloud.zj.gov.cn/class/%E5%B7%A5%E4%BD%9C%E4%BA%BA%E5%91%98%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx"

  const enrollmentUserTemplate = "https://wlxyoss4t.oss-cn-hangzhou-zwynet-d01-a.internet.cloud.zj.gov.cn/class/%E5%AD%A6%E5%91%98%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx"

  const userCheckTemplate = "https://wlxyoss4t.oss-cn-hangzhou-zwynet-d01-a.internet.cloud.zj.gov.cn/user/%E8%87%AA%E5%8A%A8%E6%A0%B8%E5%AF%B9%E5%AF%BC%E5%85%A5%E6%A8%A1%E7%89%88%20.xlsx"
export {
  smallClassGroup,
  classGroup,
  bookTemplate,
  classStudentTemplate,
  trainClassTemplate,
  studentsTemplate,
  examCollageTemplate,
  questionsTemplate,
  surveyMemberTemplate,
  notSystemUserTemplate,
  userPatchTemplate,
  liaisonRoomTemplate,
  topicLectureTemplate,
  dailyScheduleTemplate,
  retireImportByMobileTemplate,
  retireImportByBirthdayTemplate,
  retireImportTemplate,
  seatImportTemplate,
  videoIncludeInfoTemplate,
  centerSelectClassTemplate,
  roomManageTemplate,
  permissionTransferTemplate,
  liveExportUserTemplate,
  questionnaireTemplate,
  topicLectureLearnTemplate,
  cdnRecordTemplate,
  admissionNoticeTemplate,
  otherTrainRecordTemplate,
  tempModifyMobileTemplate,
  offlineVideoTemplate,
  offlineVideoSetTemplate,
  classWorkerTemplate,
  liaisonTemplate,
  enrollmentUserTemplate,
  userCheckTemplate
};
